module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  siteTitle: 'Dylan Sather', // Navigation and Site Title
  siteTitleAlt: 'Dylan Sather Personal Website', // Alternative Site title for SEO
  siteUrl: 'https://dylburger.com/', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: './favicon.ico', // Used for SEO and manifest
  siteDescription: 'Dylan Sather Personal Website',
  userTwitter: 'DylanSather', // Twitter Username
  // og: Meta Tags
  googleAnalyticsID: 'UA-63348257-2',
  copyright: 'Copyright © 2018. Dylan Sather.', // Copyright in the footer of the site
  // You can translate these three words into your language if you want.
  // They'll be shown on the project page header
  client: 'Client',
  date: 'Date',
  service: 'Service',
  // Date format used in your project header
  // More information here: https://date-fns.org/v1.29.0/docs/format
  dateFormat: 'DD.MM.YYYY',
  // Manifest and Progress color
  themeColor: '#3498DB',
  backgroundColor: '#2b2e3c',
  // Settings for typography.js
  headerFontFamily: 'Merriweather',
  bodyFontFamily: 'Roboto',
  baseFontSize: '16px',
};



// WEBPACK FOOTER //
// ./config/SiteConfig.js